import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import { useCallback, useMemo, useState } from "react";
import StepConnector from "@mui/material/StepConnector";
import { useStyles } from "./styles";
import TabPanel from "../../components/TabPanel";
import { SelectedFormat } from "./Tabs/SelectedFormat";
import { CreatedArt } from "./Tabs/CreatedArt";

export function NewArt() {
  const [currentStep, setCurrentStep] = useState<number>(0);
  const styles = useStyles();

  const steps = useMemo(() => {
    return ["1. Escolha o formato", "2. Edite a imagem"];
  }, []);

  const handleSelectedFormat = useCallback((data: any) => {
    setCurrentStep((prevState) => prevState + 1);
  }, []);

  const handleGoBack = useCallback(() => {
    setCurrentStep((prevState) => prevState - 1);
  }, []);

  return (
    <Stack spacing={2}>
      <Stack
        display={currentStep === 0 ? "none" : "flex"}
        className={styles.stackStepper}
        direction="row"
        justifyContent="center"
      >
        <Stepper
          className={styles.rootStepper}
          connector={<StepConnector classes={{ line: styles.lineStepper }} />}
        >
          {steps.map((label) => (
            <Step key={label}>
              <Typography fontWeight={500} variant="body2" color="primary">
                {label}
              </Typography>
            </Step>
          ))}
        </Stepper>
      </Stack>
      <TabPanel index={0} value={currentStep}>
        <SelectedFormat onChange={handleSelectedFormat} />
      </TabPanel>
      <TabPanel index={1} value={currentStep}>
        <CreatedArt goBack={handleGoBack} />
      </TabPanel>
    </Stack>
  );
}
